import { render, staticRenderFns } from "./MinisiteRegister.vue?vue&type=template&id=2e503c4a&scoped=true&"
import script from "./MinisiteRegister.vue?vue&type=script&lang=js&"
export * from "./MinisiteRegister.vue?vue&type=script&lang=js&"
import style0 from "./MinisiteRegister.vue?vue&type=style&index=0&id=2e503c4a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e503c4a",
  null
  
)

export default component.exports